import "./App.css";
import "./master.scss";
import "./master-m.scss";
import "./rwd.css";
import React, { Suspense } from "react";
import TagManager from "react-gtm-module";
import packageJson from "../package.json";
import Loader from "./components/Loader";
const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const ResultPage = React.lazy(() => import("./pages/ResultPage"));

const mode = 0;
const tagManagerArgs = {
  gtmId: "GTM-MCKRGN9",
};

TagManager.initialize(tagManagerArgs);

console.log("Version: " + packageJson.version);

const App = () => {
  return mode === 1 ? (
    <Suspense fallback={<Loader />}>
      <React.Fragment>
        <ResultPage />
      </React.Fragment>
    </Suspense>
  ) : (
    <Suspense fallback={<Loader />}>
      <React.Fragment>
        <LandingPage />
      </React.Fragment>
    </Suspense>
  );
};

export default App;
